import { render } from "./Personnummer.vue?vue&type=template&id=772abfc1&scoped=true"
import script from "./Personnummer.vue?vue&type=script&lang=js"
export * from "./Personnummer.vue?vue&type=script&lang=js"

import "./Personnummer.vue?vue&type=style&index=0&id=772abfc1&scoped=true&lang=css"

import exportComponent from "/home/ola/DevelopmentProjects/testdatano/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772abfc1"]])

export default __exports__